let start
let lastTime
let down = 0
// <div id="transparentBox" style="position: absolute;width: 100%;height: 100%;z-index: 9999;margin: 0;padding: 0;top: 0;left: 0;"></div>
class Scoll {
  constructor () {
    let that = this
    this.enable()
    let ID = document.getElementById('transparentBox')
    ID.addEventListener('touchstart', function (e) {
      down = 1
      that.touchstart(e)
    }, false)
    ID.addEventListener('touchmove', function (e) {
      if (down === 1) {
        that.move(e)
      }
    }, false)
    ID.addEventListener('touchend', function (e) {
      down = 0
      that.end(e)
    }, false)
    ID.addEventListener('mousedown', function (e) {
      down = 1
      that.touchstart(e)
    }, false)
    ID.addEventListener('mousemove', function (e) {
      if (down === 1) {
        that.move(e)
      }
    }, false)
    ID.addEventListener('mouseup', function (e) {
      down = 0
      that.end(e)
    }, false)
    ID.addEventListener('mousewheel', function (e) {
      that.mousewheel(e)
    }, false)
    this.init()
    this.inertia()
    // 开启监听
  }
  disable () {
    if(document.getElementById('transparentBox')){
        document.getElementById('transparentBox').remove()
    }
  }
  enable () {
    if(document.getElementById('transparentBox')){
        document.getElementById('transparentBox').style.display = 'block'
    }
  }
  inertia () {
    start.velocity.x = isFinite(start.velocity.x) ? start.velocity.x : 0
    start.velocity.y = isFinite(start.velocity.y) ? start.velocity.y : 0
    if (!start.inertiaTime) {
      start.inertiaTime = this.now()
    } else if (start.velocity.x !== 0 || start.velocity.y !== 0) {
      let time = this.now()
      let forceX = start.velocity.x * start.u
      let forceY = start.velocity.y * start.u
      let accX = forceX / start.mass
      let accY = forceY / start.mass
      let deltaTime = time - start.inertiaTime
      let velX = start.velocity.x - (accX * deltaTime)
      let velY = start.velocity.y - (accY * deltaTime)
      velX = !isNaN(velX) ? velX : 0
      velY = !isNaN(velY) ? velY : 0
      start.velocity.x = velX
      start.velocity.y = velY
      // console.log(start.velocity.y)
      let deltaX = velX * deltaTime
      let deltaY = velY * deltaTime
      start.lastCoords.x = start.currentCoords.x
      start.lastCoords.y = start.currentCoords.y
      start.currentCoords.x += deltaX
      start.currentCoords.y += deltaY
      // console.log(start.currentCoords.y)
      start.inertiaTime = time
    }
    window.requestAnimationFrame(this.inertia.bind(this))
  }
  now () {
    return (new Date()).valueOf()
  }
  init () {
    start = {
      startPoint: {
        x: 0,
        y: 0
      },
      lastPoint: {
        x: 0,
        y: 0
      },
      currentCoords: {
        x: 0,
        y: 0
      },
      lastCoords: {
        x: 0,
        y: 0
      },
      velocity: {
        x: 0,
        y: 0
      },
      lastTime: this.now(),
      inertiaTime: lastTime,
      mass: 1000,
      u: 4,
      wheelRatio: 1000,
      mouseRatio: 20,
      touchRatio: 2,
      frameRate: 60
    }
  }
  calculateVelocity (e) {
    let time = this.now()
    let deltaTime = time - start.lastTime
    let velX = start.velocity.x + ((start.lastCoords.x / deltaTime) / (e.pageX ? start.mouseRatio : start.touchRatio))
    let velY = start.velocity.y + ((start.lastCoords.y / deltaTime) / (e.pageY ? start.mouseRatio : start.touchRatio))
    velX = isFinite(velX) ? velX : 0
    velY = isFinite(velY) ? velY : 0
    return {
      x: velX,
      y: velY
    }
  }
  touchstart (e) {
    let x = e.pageX || e.changedTouches[0].pageX
    let y = e.pageY || e.changedTouches[0].pageY
    start.lastCoords = {
      x: 0,
      y: 0
    }
    start.startPoint = {
      x: x,
      y: y
    }
    start.velocity = {
      x: 0,
      y: 0
    }
  }
  move (e) {
    e.preventDefault()
    start.lastTime = this.now()
    let x = e.pageX || e.changedTouches[0].pageX
    let y = e.pageY || e.changedTouches[0].pageY
    let deltaX = x - start.startPoint.x
    let deltaY = y - start.startPoint.y
    start.lastPoint = start.startPoint
    start.startPoint = {
      x: x,
      y: y
    }
    start.lastCoords.x = deltaX
    start.lastCoords.y = deltaY
    start.currentCoords.x += deltaX
    start.currentCoords.y += deltaY
  }
  end (e) {
    e.preventDefault()
    start.inertiaTime = null
    start.velocity = this.calculateVelocity(e)
  }
  mousewheel (e) {
    start.inertiaTime = this.now()
    e.preventDefault()
    if (start.velocity.x === 0 && start.velocity.y === 0) {
      start.inertiaTime = this.now()
    }
    let deltaX = e.deltaX || 0
    let deltaY = e.deltaY || 0
    start.velocity.x -= deltaX / start.wheelRatio
    start.velocity.y -= deltaY / start.wheelRatio
  }
  return () {
    let resule = (start.currentCoords.y / 20)
    return resule
  }
}
export default Scoll



// WEBPACK FOOTER //
// ./src/js/views/Scoll.js